/**
 * Čisté formátovací funkce jobs UI (port z design návrhu „Joby na pozadí").
 */

/** Doba běhu: „9,4 s" (pod 10 s), „37 s" (pod 90 s), jinak „2 min 5 s". */
export function formatDuration(ms: number): string {
  const seconds = Math.max(ms, 0) / 1000;
  if (seconds < 10) return `${seconds.toFixed(1).replace('.', ',')} s`;
  if (seconds < 90) return `${Math.round(seconds)} s`;
  const minutes = Math.floor(seconds / 60);
  return `${minutes} min ${Math.round(seconds - minutes * 60)} s`;
}

/** Tisíce oddělené úzkou nezlomitelnou mezerou (U+202F): 10000 → „10 000". */
export function formatThousands(value: number): string {
  return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}
